<script>
  import { onMount } from "svelte";
  import { Badge } from "spaper";
  import { Icon } from "svelte-awesome";
  import { faSpinner } from "@fortawesome/free-solid-svg-icons";

  export let text = "Enviar";
  export let action;
  export let klass;

  let inAction = false;

  const performAction = async () => {
    const _text = text;
    inAction = true;
    await action();
    text = _text;
    inAction = false;
  };

</script>

{#if !inAction}
  <button class={klass} on:click={performAction}>{text}</button>
{:else}
<button class={klass}>
  <Icon data={faSpinner} scale="2" pulse></Icon>
</button>
{/if}

